import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { SnackbarService } from 'src/app/snackbar.service';
import { HttpService } from 'src/app/http.service';
import { Messages } from '../../constants/messages';
import { X } from '@angular/cdk/keycodes';

@Component({
  selector: 'app-load-dashboard-accept-modal',
  templateUrl: './load-dashboard-accept-modal.component.html',
  styleUrls: ['./load-dashboard-accept-modal.component.scss']
})

export class LoadDashboardAcceptModalComponent implements OnInit {
  acceptNumber: number;
  availableNumber = 0;

  columnsToDisplay: string[] = ['allocated'];
  columnsToDisplay2: string[] = ['customerName', 'availableLoad'];

  acceptArr = [
    { availableVehicles: '2 free', reserve: '2' }
  ];

  orgDetails: any = {
    organizationName: '',
    orderNo: '',
    vehicleType: '',
    allocated: '',
    offeredPrice: '',
    distance: ''
  };

  location: any = {
    start: 'Mumbai',
    destination: 'Bangalore',
  };
  currencySymbol: any;
  vehicle = {
    _id: '',
    name: ''
  };
  messages = new Messages();
  isPallet = false;
  allocation_type = '';
  available_plan = [];
  accepted_plan = [];
  //   accepted_plan=[
  //     {name:'test1',weight:0},
  //    {name:'test2',weight:0},
  //    {name:'test3',weight:0}
  // ];

  totalValue = 0;

  constructor(private dialog: MatDialogRef<LoadDashboardAcceptModalComponent>,
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private snack: SnackbarService,
    private http: HttpService
  ) { }

  ngOnInit() {

    this.availableNumber = 0;

    const currency = JSON.parse(localStorage.getItem('carriers'));
    this.currencySymbol = currency[0].country.currency.symbol;
    this.accepted_plan = this.parentData.customer.map(c => c.name).join(', ');
    this.accepted_plan = [{ name: this.accepted_plan, weight: 0}];
  }

  calTotol() {
    this.totalValue = this.accepted_plan.reduce((sum, item) => sum + item.weight, 0);

  }

  closeAcceptModal(data = '') {
    this.dialog.close(data);
  }

  number_test(n) {
    const result = (n - Math.floor(n)) !== 0;
    if (result) {
      return true;
    } else {
      return false;
    }
  }

  accept(temp: any, type = 'accept') {
    let acceptedPlans = this.accepted_plan;
    if (this.totalValue > this.parentData.allocated) {
      this.snack.openSnackBar(`Please check allocated quantity ${this.parentData.allocated} MT. Accepted can't be greater than Allocated`, '', 'err');
      return;
    }
    let data = []
    if (type == 'reject') {
      acceptedPlans = [];
      this.available_plan.forEach(x => acceptedPlans.push({ name: x.name, weight: 0 }));
    } else {
      this.available_plan.forEach(function (x) {
        let y = acceptedPlans.find(c => c.name === x.name);
        if (y.weight > x.weight) {
          data.push(x)
          return;
        }
      })
      if (data.length > 0) {
        this.snack.openSnackBar(data[0].name + 'Please check available plan', '', 'err');
        return;
      }
    }


    let url: any = 'v2/loads/accept';
    if (this.parentData.type == 'accept_more') {
      url = 'loads/add_free_load'
    }
    const acceptData: any = {
      load_allocation_id: this.parentData.allocation_id,
      accepted_load: this.parentData.allocated,
      // accepted_plan: this.accepted_plan
      accepted_plan: acceptedPlans
    };
    this.http.post(url, acceptData).subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          this.snack.openSnackBar(this.messages.DASHBOARD_MODALS.ACCEPT_MODAL.SUCCESS.ORDER_ACCEPT);
          this.closeAcceptModal(data);
        } else {
          this.snack.openSnackBar(this.messages.DASHBOARD_MODALS.ACCEPT_MODAL.ERROR.TRY_AGAIN, '', 'err');
        }
      },
      (err: any) => {
        if (err.error.statusCode == 400 || err.error.statusCode == 403) {
          this.snack.openSnackBar(err.error.message, '', 'err');
        } else {
          this.snack.openSnackBar(this.messages.DASHBOARD_MODALS.ACCEPT_MODAL.ERROR.TRY_AGAIN, '', 'err');
        }
      }
    );
    // }
  }

  accept2(element) {

    let data = {
      load_allocation_id: element._id,
      accepted_load: element.allocated
    }

    this.http.post('loads/accept', data).subscribe(
      (data: any) => {
        if (data.statusCode == 200) {
          this.snack.openSnackBar(this.messages.DASHBOARD_MODALS.ACCEPT_MODAL.SUCCESS.ORDER_ACCEPT);
          this.closeAcceptModal(data);
        }
      },
      (err: any) => {
        if (err.error.statusCode == 400 || err.error.statusCode == 403) {
          this.snack.openSnackBar(err.error.message, '', 'err');
        } else {
          this.snack.openSnackBar(this.messages.DASHBOARD_MODALS.ACCEPT_MODAL.ERROR.TRY_AGAIN, '', 'err');
        }
      }
    );
  }
}
